import { createRouter, createWebHashHistory } from 'vue-router'
import Home from '../views/Home'
import Login from "../views/Login";
import Game from "../views/Game"
import auth from "../auth";

const routes = [
  {
    path: '/auth',
    name: 'Login',
    component: Login
  },
  {
    path: '/',
    name: 'Main',
    component: Home
  },

  {
    path: '/game/:seed',
    name: 'Game',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: Game
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

router.beforeEach((to, from, next) => {

  if (to.name !== 'Login' && !auth.state.logged) {
    next({ name: 'Login' })
  } else {
    next();
  }
})

export default router
